import { useMemo } from 'react';

import { collection, orderBy, Query, query } from 'firebase/firestore';

import { useCollectionData } from 'react-firebase-hooks/firestore';

import { useData } from '../contextProviders/DataProvider';
import { firestore } from '../firebase';
import { WeatherLocation } from '../types/WeatherLocation';

export default function useWeatherLocations() {
  const { userState } = useData();

  const weatherLocationQuery = useMemo(() => {
    if (userState.status !== 'ready' || !userState.userProfile) return null;
    return query(
      collection(firestore, 'weatherLocation') as Query<WeatherLocation>,
      orderBy('name')
    );
  }, [userState.userProfile, userState.status]);

  const [weatherLocations, isLoading, error] = useCollectionData<WeatherLocation>(weatherLocationQuery);

  return {
    weatherLocations: weatherLocations ?? [],
    isWeatherLocationsLoading: isLoading || userState.status !== 'ready',
    weatherLocationsError: error,
  };
}
